import { SVGProps } from 'react';

const SvgMail2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.25 8.75C4.25 8.08696 4.51339 7.45107 4.98223 6.98223C5.45107 6.51339 6.08696 6.25 6.75 6.25H24.25C24.913 6.25 25.5489 6.51339 26.0178 6.98223C26.4866 7.45107 26.75 8.08696 26.75 8.75M4.25 8.75V21.25C4.25 21.913 4.51339 22.5489 4.98223 23.0178C5.45107 23.4866 6.08696 23.75 6.75 23.75H24.25C24.913 23.75 25.5489 23.4866 26.0178 23.0178C26.4866 22.5489 26.75 21.913 26.75 21.25V8.75M4.25 8.75L15.5 16.25L26.75 8.75"
      stroke="#2196F3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgMail2;
